import Box from '@rsos/base-components/Box';
import styled from '@rsos/theme/styled';

export const Wrapper = styled(Box)`
  position: relative;
  border-radius: 5px;
  margin: 0px 10px;
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.1);
  background: ${({ theme }) => theme.colors.primaryBase};
  color: ${({ theme }) => theme.colors.background};
`;

export const Content = styled(Box)`
  padding: 8px 12px;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  gap: 10px;
  > p {
    margin: 0;
  }
`;
